/*
 * @Author: hongye yanghongye@jtexpress.com
 * @Date: 2025-08-28 16:25:18
 * @LastEditors: hongye
 * @LastEditTime: 2025-08-28 16:25:53
 * @Description: file content
 */
/**名称和URL关联枚举 */
enum UnionEnum {
  /**首页 */
  Home,
  /**异常支付审核 */
  ABNORMALPAYMENT,
  /**下载中心 */
  DownLoad,
  /**国内件 */
  ORDERWRITER,
  /**地址簿 */
  ADDRESS,
  /**订单列表 */
  ORDERLIST,
  /**资金管理 */
  ORDERMANAGER,
  /**notFound */
  NOTFOUND,
  /**确认订单 */
  CONFIRMORDER,
  /**资金账户 */
  CAPITALACCOUNT,
  /**无权限 */
  NOAUTH,
  /**登录 */
  LOGIN,
  /**找回密码 */
  FINDPASSWORD,
  /**站点管理 */
  STOREMANAGEMENT,
  /**预付款管理 */
  ADVANCE_MANAGEMENT,
  /**COD预付款管理 */
  COD_ADVANCE_MANAGEMENT,
  /**预付款审核 */
  AUDIT_MANAGEMENT,
  /**COD预付款审核 */
  COD_AUDIT_MANAGEMENT,
  /**预付款查询 */
  ADVANCE_INQUIRY,
  /**COD预付款查询 */
  COD_ADVANCE_INQUIRY,
  /**扣款失败查询 */
  FAILURE_MANAGEMENT,
  /**COD扣款失败查询 */
  COD_FAILURE_MANAGEMENT,
  /**i18n */
  I18N
}
/**name 枚举 */
enum NameEnum {
  首页 = UnionEnum.Home,
  异常支付审核 = UnionEnum.ABNORMALPAYMENT,
  订单录入 = UnionEnum.ORDERWRITER,
  客户管理 = UnionEnum.ADDRESS,
  下载中心 = UnionEnum.DownLoad,
  找回密码 = UnionEnum.FINDPASSWORD,
  确认订单 = UnionEnum.CONFIRMORDER,
  资金管理 = UnionEnum.ORDERMANAGER,
  订单列表 = UnionEnum.ORDERLIST,
  无权限 = UnionEnum.NOAUTH,
  登录 = UnionEnum.LOGIN,
  notFound = UnionEnum.NOTFOUND,
  站点设置 = UnionEnum.STOREMANAGEMENT,
  预付款管理 = UnionEnum.ADVANCE_MANAGEMENT,
  COD预付款管理 = UnionEnum.COD_ADVANCE_MANAGEMENT,
  预付款审核 = UnionEnum.AUDIT_MANAGEMENT,
  COD预付款审核 = UnionEnum.COD_AUDIT_MANAGEMENT,
  预付款查询 = UnionEnum.ADVANCE_INQUIRY,
  COD预付款查询 = UnionEnum.COD_ADVANCE_INQUIRY,
  扣款失败查询 = UnionEnum.FAILURE_MANAGEMENT,
  COD扣款失败查询 = UnionEnum.COD_FAILURE_MANAGEMENT,
  国际化 = UnionEnum.I18N
}
/**Url 枚举 */
enum UrlEnum {
  '/' = UnionEnum.Home,
  /**异常支付审核 */
  '/abnormalPayment' = UnionEnum.ABNORMALPAYMENT,
  '/download/center' = UnionEnum.DownLoad,
  '/order' = UnionEnum.ORDERWRITER,
  '/setting/address' = UnionEnum.ADDRESS,
  '/noAuth' = UnionEnum.NOAUTH,
  '/login' = UnionEnum.LOGIN,
  '/findPwd' = UnionEnum.FINDPASSWORD,
  '/orderQuery' = UnionEnum.ORDERLIST,
  '/notFound' = UnionEnum.NOTFOUND,
  '/account' = UnionEnum.CAPITALACCOUNT,
  '/order/confirmOrder' = UnionEnum.CONFIRMORDER,
  '/storeManagement' = UnionEnum.STOREMANAGEMENT,
  '/advanceManagement' = UnionEnum.ADVANCE_MANAGEMENT,
  '/codAdvanceManagement' = UnionEnum.COD_ADVANCE_MANAGEMENT,
  '/auditManagement' = UnionEnum.AUDIT_MANAGEMENT,
  '/codAuditManagement' = UnionEnum.COD_AUDIT_MANAGEMENT,
  '/advanceInquiry' = UnionEnum.ADVANCE_INQUIRY,
  '/codAdvanceInquiry' = UnionEnum.COD_ADVANCE_INQUIRY,
  '/failureManagement' = UnionEnum.FAILURE_MANAGEMENT,
  '/codFailureManagement' = UnionEnum.COD_FAILURE_MANAGEMENT,
  '/i18n' = UnionEnum.I18N
}
export { NameEnum, UrlEnum, UnionEnum }
